import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
//api
import { getProvinces } from 'api/company';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchProvince = ({
  filterBy,
  onSelected,
  placeholder,
  defaultProvince,
  invoice = false
}) => {
  const { t } = useTranslation(['backoffice']);
  const [provinceSelected, setProvinceSelected] = useState(null);
  const [provinces, setProvinces] = useState([]);

  const withInvoice = () => {
    if (defaultProvince) {
      setProvinceSelected({
        label: defaultProvince[filterBy],
        value: defaultProvince.id,
      });
    } else setProvinceSelected(null)
  }

  useEffect(() => {
    async function fetchProvinces() {
      const { status, data } = await getProvinces();
      if (status === 200) {
        setProvinces(data);
        if (defaultProvince) {
          const foundProvince = data.find(province => province.id === defaultProvince);
          if (foundProvince) {
            setProvinceSelected(foundProvince);
          }
        }
      }
    }
    if (invoice)
      withInvoice();
    else fetchProvinces();
  }, [defaultProvince]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getProvinces({
        [filterBy]: value,
        page: 1,
        page_size: 10
      });
      if (status === 200) {
        return data?.map((item) => ({
          ...item,
          label: item.nombre,
          value: item.id,
        }));
      }
    }
    return [];
  };

  const handleSelect = (selectedOption) => {
    if (selectedOption) {
      setProvinceSelected(selectedOption);
      onSelected(selectedOption.value);
    } else {
      setProvinceSelected(null);
      onSelected(null);
    }
  };

  const placeholderText = provinceSelected ? provinceSelected.nombre : placeholder;

  return (<>
    {invoice ?
      <AutoCompleteInput
        label={t('Provincia')}
        placeholder={placeholderText}
        defaultOptions={provinceSelected ? [provinceSelected] : []}
        defaultValue={provinceSelected}
        onSelect={onSelected}
        onSearch={onSearch}
      /> :
      <AutoCompleteInput
        label={t('Provincia')}
        placeholder={placeholderText}
        defaultOptions={provinceSelected ? [{ label: provinceSelected.nombre, value: provinceSelected.id }] : []}
        value={provinceSelected ? provinceSelected.id : null}
        onSelect={handleSelect}
        onSearch={onSearch}
      />}
  </>
  );
};

SearchProvince.propTypes = {
  filterBy: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultProvince: PropTypes.number,
  invoice: PropTypes.bool,
};

export default SearchProvince;
